import { TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTableHeadCell = styled(TableCell)(({ theme }) => ({
  height: '56px',
  borderColor: theme.palette.grey[800],
  backgroundColor: theme.palette.grey[900],
  color: `${theme.palette.grey[50]} !important`,
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  height: '64px',
  borderColor: theme.palette.grey[800],
}));

export const BottomIconWrapper = styled('div')(({ theme }) => ({
  textAlign: 'center',
  // position: 'absolute',
  zIndex: 1,
  width: '100%',
  height: '48px',
  bottom: 0,
  backgroundColor: theme.palette.grey[900],
}));
